import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en';
import zhTW from './locales/zh-TW';
import ja from './locales/ja';
import {
  DEFAULT_LANGUAGE,
  LANGUAGE_STORAGE_KEY,
  resolveInitialLanguage,
  type Language,
} from './config';

export const resources = {
  en: { translation: en },
  'zh-TW': { translation: zhTW },
  ja: { translation: ja },
} as const;

// Resources are bundled, so init resolves synchronously — the instance is ready
// before the first render. `useSuspense: false` keeps that guarantee explicit
// so consumers never need a Suspense boundary.
void i18n.use(initReactI18next).init({
  resources,
  lng: resolveInitialLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: { escapeValue: false }, // React already escapes.
  returnNull: false,
  react: { useSuspense: false },
});

/** Reflect the active locale on <html lang> for a11y and browser features. */
function syncDocumentLang(lng: string) {
  // Guard `document` so importing i18n is safe in node-env tests / SSR.
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng;
  }
}
i18n.on('languageChanged', syncDocumentLang);
syncDocumentLang(i18n.language);

/** Switch language and persist the choice (analytics stays with the caller). */
export function setLanguage(lang: Language) {
  void i18n.changeLanguage(lang);
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  }
}

export default i18n;
